import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import Box from '@mui/material/Box';

import FormLine from 'src/components/ui/FormLine';
import { FORM_LINE_TYPES } from 'src/components/ui/FormLine/constants';
import Autocomplete from 'src/components/ui/Autocomplete';
import Datepicker from 'src/components/ui/DatePicker';

const StatusField = (props) => {
	const {
		label,
		status,
		date,
		reason,
		tillLabel = 'до',
		withDate,
		withReason,
		connected,
	} = props;
	return (
		<Stack spacing={1.5}>
			{label && <InputLabel>{label}</InputLabel>}
			<Stack direction="row" alignItems="center" gap={2}>
				<Box sx={{ minWidth: 160, flexGrow: 1 }}>
					<FormLine
						connected={connected}
						type={FORM_LINE_TYPES.autocomplete}
						params={status}
					/>
				</Box>
				{withDate && (
					<Stack
						sx={{ flexBasis: '100%', flexGrow: 1 }}
						direction="row"
						alignItems="center"
						gap={1.5}
					>
						{tillLabel}
						<Box sx={{ flexGrow: 1 }}>
							<FormLine
								connected={connected}
								type={FORM_LINE_TYPES.datepicker}
								params={date}
							/>
						</Box>
					</Stack>
				)}
			</Stack>
			{withReason && (
				<FormLine
					connected={connected}
					type={FORM_LINE_TYPES.autocomplete}
					params={reason}
				/>
			)}
		</Stack>
	);
};

StatusField.propTypes = {
	label: PropTypes.string,
	status: PropTypes.shape(Autocomplete.propTypes),
	date: PropTypes.shape(Datepicker.propTypes),
	reason: PropTypes.shape(Autocomplete.propTypes),
	tillLabel: PropTypes.string,
	withDate: PropTypes.bool,
	withReason: PropTypes.bool,
	connected: PropTypes.bool,
};

export default StatusField;
